import Routes from '@/utils/routes';

/**
 * Rotas do onboarding.
 *
 * A sessão do avaliado é autenticada como qualquer outra tela do app: o token no
 * caminho identifica o link, mas quem identifica a pessoa é o login do Firebase. É
 * isso que impede alguém de fazer a prova pelo colega — o backend só devolve o
 * assignment cujo dono é o usuário logado.
 *
 * Todas carregam sob demanda: o chunk do onboarding não entra no bundle principal.
 */
export const OnboardingRoutes = [
	{
		path: '/onboarding/:token',
		name: Routes.OnboardingSession,
		component: () => import('./OnboardingSessionView'),
	},
	{
		path: '/admin/onboarding',
		name: Routes.OnboardingAssignments,
		component: () => import('./admin/OnboardingAssignmentsView'),
	},
	{
		path: '/admin/onboarding/report',
		name: Routes.OnboardingAreaReport,
		component: () => import('./admin/OnboardingAreaReportView'),
	},
	{
		path: '/admin/onboarding/:assignmentId',
		name: Routes.OnboardingAssignmentDetail,
		component: () => import('./admin/OnboardingAssignmentDetailView'),
		props: true,
	},
];

export default OnboardingRoutes;
